module.exports = __webpack_public_path__ + "img/petik-atas.7fd4f52a.svg";